import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import lottie from 'lottie-web';
import { defineElement } from 'lord-icon-element';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// Registra el custom element <lord-icon> usando lottie-web local (sin CDN).
defineElement(lottie.loadAnimation);

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
